import Base from '../Base';
export default class TitreADecouvrir extends Base {
    init(id, main, locale) {
        console.log(':: TitreADecouvrir ::');

        var els = document.getElementsByClassName('tableContainer');

        Array.from(els).forEach(el => {
            el.addEventListener('scroll', () => {
                el.classList.add('scrollTable');
            });
        });

        $('.collapse').on('show.bs.collapse', function(e) {
            var $card = $(this).closest('.card');
            var $open = $($(this).data('parent')).find('.collapse.show');

            var additionalOffset = 0;
            if ($card.prevAll().filter($open.closest('.card')).length !== 0) {
                additionalOffset = $open.height();
            }
            $('html,body').animate({
                scrollTop: $card.offset().top - additionalOffset,
            }, 1000);
        });
    }
}